import { pathRedirect } from '@/utils/auth'

import Collector from '@/containers/TelnetReading/Collector'
// import Repeater from '@/containers/TelnetReading/Repeater'
import DeviceInfo from '@/containers/TelnetReading/DeviceInfo'
import Counter from '@/containers/TelnetReading/counter'
import Area from '@/containers/TelnetReading/Area'
import PeriodSetting from '@/containers/TelnetReading/PeriodSetting'
import WaterList from '@/containers/TelnetReading/WaterList.vue'
import WateruserHistory from '@/containers/TelnetReading/WateruserHistory.vue'
import WaterUnused from '@/containers/TelnetReading/WaterUnused.vue'
import DataQuery from '@/containers/TelnetReading/DataQuery.vue'
import MonthAnalysis from '@/containers/TelnetReading/MonthAnalysis.vue'
import DataQueryHistory from '@/containers/TelnetReading/DataQueryHistory.vue'
import testMultSelect from '@/containers/TelnetReading/testMultSelect'
import WaterAllLists from '@/containers/TelnetReading/WaterAllLists'

export default {
  path: 'telnetReading',
  redirect: pathRedirect,
  children: [
    { path: 'deviceInfo', component: DeviceInfo },
    { path: 'collector', component: Collector },
    { path: 'counter', component: Counter },
    { path: 'area', component: Area },
    { path: 'periodSetting', component: PeriodSetting },
    // { path: 'history', component: WateruserHistory, name: '用水历史' },
    { path: 'history/:counterId', component: WateruserHistory, name: '抄表历史' },
    { path: 'unusedHistory/:counterId', component: WateruserHistory, name: '无用水历史' },
    { path: 'waterList', component: WaterList },
    { path: 'waterUnused', component: WaterUnused },
    { path: 'monthAnalysis', component: MonthAnalysis },
    { path: 'dataQuery', component: DataQuery },
    { path: 'dataQueryHistory/:counterId', component: DataQueryHistory, name: '历史数据' },
    { path: 'waterAllLists', component: WaterAllLists },
    { path: 'waterAllHistory/:counterId', component: WateruserHistory, name: '抄表数据历史' },
    { path: 'test', component: testMultSelect }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/telnetReading.js